export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    if (!favicon.dataset.originalHref) {
      favicon.dataset.originalHref = favicon.getAttribute('href');
    }
    const sizes = favicon.sizes && favicon.sizes[0];
    const sizeSuffix = sizes ? `-${sizes}` : '';
    const newFileName = `/favicon-badge${sizeSuffix}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        if (favicon.dataset.originalHref) {
          favicon.href = favicon.dataset.originalHref;
        } else {
          const sizes = favicon.sizes && favicon.sizes[0];
          const sizeSuffix = sizes ? `-${sizes}` : '';
          const oldFileName = `/favicon${sizeSuffix}.png`;
          favicon.href = oldFileName;
        }
      });
    }
  });
};
